import { SOAP_PREFERENCE_SETTING_NAMES } from '@chiroup/core/constants/SOAPPreferences';
import useConditionDetails from '../../../../hooks/useConditionDetails';
import useEvaluations from '../../../../hooks/useEvaluations';
import useMuscles from '../../../../hooks/useMuscles';
import useComplaintConditions from '../../../patients/hooks/useComplaintConditions';
import useSettings from '../../../report/hooks/useSettings';

/**
 * Pre-warms the React Query caches the later sandbox steps read, so entering
 * "Finalize OAP" doesn't sit on a spinner: UnifiedObjectiveStep's Joints panel
 * gates on the conditionDetails fetch, and Myofascial/Orthopedic/ROM need
 * muscles, evaluations, and the ROM-step setting. Runs from the sandbox shell,
 * so the fetches start the moment a diagnosis is selected (steps 1–2), well
 * before the prospect clicks into OAP. Each call uses the exact query key its
 * consumer uses, so the consumer mounts straight onto fresh cache.
 */
export const useSandboxWarmup = (conditionIds: number[]) => {
  // Same key as UnifiedObjectiveStep's useConditionDetails({ids}) — the fetch
  // the Joints spinner waits on. Empty ids short-circuit in the service.
  useConditionDetails({ ids: conditionIds, refetchOnMount: false });
  // Orthopedic suggestions + note builder (hide defaults to true everywhere).
  useEvaluations({ hide: true, refetchOnMount: false });
  // Myofascial muscle names + note builder.
  useMuscles({ refetchOnMount: false });
  // ROM slider step preference.
  useSettings({ type: SOAP_PREFERENCE_SETTING_NAMES.SOAP_PREFERENCES });
  // Review & Sign's assessment/note generation (lightweight condition fetch).
  useComplaintConditions(conditionIds, true);
};
